var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        id: "beer_can",
        xmlns: "http://www.w3.org/2000/svg",
        width: "100",
        height: "100",
        viewBox: "0 0 100 100",
      },
    },
    [
      _c("path", {
        staticStyle: { fill: "none", "stroke-width": "0px" },
        attrs: {
          d: "m49.979,28.563c9.584,0,15.414-1.521,16.717-2.302l-.974-2.782c-3.361,1.601-11.52,2.181-15.743,2.181s-12.383-.58-15.743-2.181l-.974,2.782c1.303.782,7.133,2.302,16.717,2.302Z",
        },
      }),
      _c("path", {
        staticStyle: { fill: "none", "stroke-width": "0px" },
        attrs: {
          d: "m50.003,85.12c-1.416,0-10.903-.07-15.855-1.836l.512,1.452c.352.839,4.042,2.526,15.343,2.526,10.547,0,14.96-1.526,15.353-2.551l.503-1.427c-4.952,1.766-14.439,1.837-15.855,1.837Z",
        },
      }),
      _c("path", {
        staticStyle: { fill: "none", "stroke-width": "0px" },
        attrs: {
          d: "m66.857,28.363c-3.608,1.572-11.435,2.199-16.878,2.199s-13.204-.622-16.832-2.18v52.064l.056.16c.824.948,6.823,2.514,16.799,2.514s15.975-1.567,16.798-2.515l.056-.159V28.363Z",
        },
      }),
      _c("path", {
        staticStyle: { fill: "#fff", "stroke-width": "0px" },
        attrs: {
          d: "m49.979,23.66c6.965,0,12.308-1.029,14.452-1.771-2.145-.742-7.487-1.77-14.452-1.77s-12.308,1.028-14.452,1.77c2.145.742,7.487,1.771,14.452,1.771Z",
        },
      }),
      _c("path", {
        staticStyle: { "stroke-width": "0px" },
        attrs: {
          d: "m68.857,26.432h-.041v-.17l-1.647-4.704-.006.002c-.882-2.566-11.998-3.441-17.184-3.441s-16.302.876-17.184,3.441l-.006-.002-1.647,4.704v.17c0,.014.004.027.005.04v54.145c0,.301.087.58.236.842l1.41,3.994c1.313,3.148,10.083,3.809,17.209,3.809,7.186,0,16.006-.666,17.229-3.861l1.389-3.942c.149-.262.236-.54.236-.841V26.432Zm-18.854,56.688c-9.976,0-15.975-1.567-16.799-2.514l-.056-.16V28.382c3.628,1.558,11.411,2.18,16.832,2.18s13.27-.627,16.878-2.199v52.083l-.056.159c-.823.948-6.823,2.515-16.798,2.515Zm14.429-61.23c-2.145.742-7.487,1.771-14.452,1.771s-12.308-1.029-14.452-1.771c2.145-.742,7.487-1.77,14.452-1.77s12.308,1.028,14.452,1.77Zm-14.452,3.771c4.223,0,12.383-.58,15.743-2.181l.974,2.782c-1.303.782-7.133,2.302-16.717,2.302s-15.414-1.521-16.717-2.302l.974-2.782c3.361,1.601,11.52,2.181,15.743,2.181Zm.023,61.602c-11.301,0-14.991-1.687-15.343-2.526l-.512-1.452c4.952,1.766,14.439,1.836,15.855,1.836s10.904-.07,15.855-1.837l-.503,1.427c-.393,1.025-4.806,2.551-15.353,2.551Z",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }